function Footer() {
  return (
    <footer class="w3-container w3-padding-32 w3-theme-d1 w3-center">
      <h4>Follow Us</h4>
      <a
        class="w3-button w3-large w3-teal"
        href="https://www.facebook.com/@investineducation/"
        title="Facebook"
      >
        <i class="fa fa-facebook"></i>
      </a>
      <a
        class="w3-button w3-large w3-teal"
        href="https://twitter.com/investin_ed"
        title="Twitter"
      >
        <i class="fa fa-twitter"></i>
      </a>

      <a
        class="w3-button w3-large w3-teal"
        href="https://www.instagram.com/investin_education/?hl=en"
        title="Instagram"
      >
        <i class="fa fa-instagram"></i>
      </a>
      <a
        class="w3-button w3-large w3-teal w3-hide-small"
        href="https://uk.linkedin.com/company/investin"
        title="Linkedin"
      >
        <i class="fa fa-linkedin"></i>
      </a>
      <a
        class="w3-button w3-large w3-teal"
        href="https://investin.org/"
        title="Website"
      >
        <i class="fa fa-globe"></i>
      </a>
    </footer>
  );
}

export default Footer;
